import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	TextField,
	MenuItem
} from "@mui/material";
import { LineItem } from "../../models/invoice";
import { ReturnItemData } from "../../models/credit";

export interface ReturnItemRecordProps {
	invoiceNumber: string;
	items: LineItem[];
	open: boolean;
	onClose: () => void;
	onSave: (data: ReturnItemData) => void;
}

const ReturnItemRecord: React.FC<ReturnItemRecordProps> = ({
	invoiceNumber,
	items,
	open,
	onClose,
	onSave
}) => {
	const [selectedItem, setSelectedItem] = useState<LineItem | null>(null);
	// const [selectedValue, setSelectedValue] = useState<string>("");
	const [quantity, setQuantity] = useState<number>(1);

	const availableItem = items.find(
		(i) => i.lineItemId === selectedItem?.lineItemId
	);
	const maxQty = availableItem ? availableItem.quantity : 1;

	const handleSave = () => {
		if (!selectedItem || quantity < 1 || quantity > maxQty) {
			alert("Select valid item and quantity");
			return;
		}
		onSave({
			invoiceNumber,
			lineItemId: selectedItem.lineItemId,
			description: selectedItem.description,
			quantity,
			amount: selectedItem.sellPrice,
			returnDate: new Date().toISOString()
		});
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Return Item</DialogTitle>
			<DialogContent>
				<Typography gutterBottom>
					Invoice Number: <b>{invoiceNumber}</b>
				</Typography>
				<TextField
					label="Item Description"
					select
					fullWidth
					margin="normal"
					value={selectedItem ? selectedItem.lineItemId : ""}
					onChange={(e) => {
						const lineItemId = e.target.value;
						setSelectedItem(
							items.find(
								(item) => item.lineItemId === lineItemId
							) || null
						);
					}}
				>
					{items.map((item, idx) => (
						<MenuItem key={idx} value={item.lineItemId}>
							{item.description} (Qty: {item.quantity}) (Code:{" "}
							{item.itemCode})
						</MenuItem>
					))}
				</TextField>
				<TextField
					label="Quantity to Return"
					type="number"
					fullWidth
					margin="normal"
					value={quantity}
					onChange={(e) => setQuantity(Number(e.target.value))}
					inputProps={{ min: 1, max: maxQty }}
				/>
			</DialogContent>
			<DialogActions
				sx={{
					flexDirection: { xs: "column", sm: "row" },
					gap: 1,
					p: { xs: 2, sm: 1 }
				}}
			>
				<Button
					onClick={onClose}
					sx={{
						width: { xs: "100%", sm: "auto" },
						m: { xs: 0, sm: 1 },
						ml: { xs: 0, sm: "auto" }
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={handleSave}
					variant="contained"
					color="primary"
					sx={{
						width: { xs: "100%", sm: "auto" },
						m: { xs: 0, sm: 1 }
					}}
				>
					Return
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ReturnItemRecord;
